<i18n>
  {
    "fr": {
      "placeholder": "Classe",
      "economy": "Classe Économique",
      "eco-plus": "Classe Eco Premium",
      "business": "Classe Affaire",
      "first": "Première Classe",
      "errors": {
        "required": "Ce champ est requis"
      }
    },
    "enf": {
      "placeholder": "Class",
      "economy": "Economy class",
      "eco-plus": "Eco plus class",
      "business": "Business class",
      "first": "First class",
      "errors": {
        "required": "Required field"
      }
    }
  }
</i18n>

<template>
  <v-select
    v-model="selectedClassType"
    data-cy="class-type-select"
    class="class-type-select"
    solo
    flat
    :items="classTypes"
    item-text="optionName"
    return-object
    :placeholder="$i18n.t('placeholder')"
    :error-messages="errors"
    @input="selectedClassTypeTouch"
    @blur="selectedClassTypeTouch"
  >
    <template #item="data">
      <v-list-item-content
        :data-cy="`class-type-select-list-item-${data.item.class_type}`"
      >
        {{ $t(data.item.optionName) }}
      </v-list-item-content>
    </template>
  </v-select>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'FlightSelectClassType',
  mixins: [validationMixin],
  computed: {
    ...mapState({
      classTypesState: state => state.fb.searchParameters.classTypes,
      selectedClassTypeState: state => state.fb.searchParameters.selectedClassType
    }),
    /**
     * This computed use the class types state from the vueX store then,
     * an attribute is mapped to each object of the array (text format)
     * @return {Object[]}
     */
    classTypes () {
      return this.classTypesState.map(entry => {
        let optionName
        switch (entry.class_text) {
          case 'Economy':
            optionName = this.$i18n.t('economy')
            break
          case 'Economy Premium':
            optionName = this.$i18n.t('eco-plus')
            break
          case 'Business':
            optionName = this.$i18n.t('business')
            break
          case 'First':
            optionName = this.$i18n.t('first')
            break
        }
        return Object.assign({}, entry, { optionName })
      })
    },
    selectedClassType: {
      /**
       * Simply return vueX store state
       * @return {Object}
       */
      get () {
        return this.selectedClassTypeState
      },
      /**
       * Set a new value to the vueX store state
       * @param newValue {Object}
       */
      set (newValue) {
        this.changeSelectedClassType(newValue)
      }
    },
    /**
     * This value need to be computed for the watcher to work properly
     * @return {boolean}
     */
    isValid () {
      return !this.$v.$invalid
    },
    /**
     * Return an array of string with errors or nothing based on vuelidate state
     * @return {string[]}
     */
    errors () {
      const errors = []
      if (!this.$v.selectedClassType.$dirty) return errors
      !this.$v.selectedClassType.required && errors.push(this.$i18n.t('errors.required'))
      return errors
    }
  },
  watch: {
    /**
     * This watcher initialise the select with the first value of the class types array,
     * this watcher exist because there is a very short amount of time where the class types are undefined
     * while waiting for the request to the backend to succeed.
     */
    classTypes () {
      this.selectedClassType = this.classTypes[0]
    },
    /**
     * Watch for value change of validity then commit the new value to the store
     * (based on isDeparture prop)
     * @param newVal {boolean}
     */
    isValid (newVal) {
      this.changeValidity(newVal)
    }
  },
  validations: {
    selectedClassType: {
      required
    }
  },
  methods: {
    ...mapMutations({
      changeSelectedClassType: 'fb/searchParameters/changeSelectedClassType',
      changeValidity: 'fb/searchParameters/changeSelectedClassTypeValidity'
    }),
    /**
     * Shortcut for vuelidate touch method
     */
    selectedClassTypeTouch () {
      this.$v.selectedClassType.$touch()
    }
  }
}
</script>

<style scoped>
</style>
